import { render, staticRenderFns } from "./AzFileShare.vue?vue&type=template&id=cb933e3c&"
import script from "./AzFileShare.vue?vue&type=script&lang=ts&"
export * from "./AzFileShare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports